import { StateCreator } from 'zustand';
import { MentionsSlice, MentionsSliceState } from './index.types';

const initialState: MentionsSliceState = {
  mentionsActiveId: null,
};

export const createMentionsSlice: StateCreator<MentionsSlice> = (set) => ({
  ...initialState,
  setMentionsActiveId: (mentionsActiveId) => set({ mentionsActiveId }),
  resetMentions: () => set({ ...initialState }),
});

